import React, { useEffect, useState } from "react";
import SearchResultsPage from "./SearchResultsPage";
import SearchResultsPageMobile from "./SearchResultsPageMobile";

export default function ResponsiveSearchResultsPage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <SearchResultsPageMobile /> : <SearchResultsPage />;
}